import { FloppyDisk, Play, DownloadSimple } from "@phosphor-icons/react";
import { fmtDateTime, fmtSize } from "@/components/backup/backupUtils";

export default function PredeploySection({ files, running, onRun, onDownload }) {
  return (
    <section className="border border-black bg-white mb-8" data-testid="backup-predeploy-section">
      <div className="border-b border-black px-6 py-4 flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2">
          <FloppyDisk size={18} weight="bold" />
          <div>
            <div className="font-head font-bold text-lg">Backup Pré-Deploy (Proteção Automática)</div>
            <div className="text-xs text-zinc-500">
              A cada reinício do servidor um backup completo é salvo em disco persistente.
              Mantemos os <b>10 mais recentes</b>. Nenhum dado se perde entre atualizações.
            </div>
          </div>
        </div>
        <button
          className="btn btn-primary"
          onClick={onRun}
          disabled={running}
          data-testid="backup-predeploy-run"
          title="Gera manualmente um backup pré-deploy agora"
        >
          <Play size={16} weight="fill" />
          {running ? "Gerando..." : "Gerar backup agora"}
        </button>
      </div>
      <div className="p-6">
        {files.length === 0 ? (
          <div className="text-sm text-zinc-500 italic">
            Ainda não há backups pré-deploy. O primeiro será gerado ~15s após cada reinício.
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="border-b border-black">
                <tr className="text-left">
                  <th className="py-2 pr-4">Arquivo</th>
                  <th className="py-2 pr-4">Gerado em</th>
                  <th className="py-2 pr-4">Tamanho</th>
                  <th className="py-2 pr-4 text-right">Ações</th>
                </tr>
              </thead>
              <tbody>
                {files.map((f) => (
                  <tr key={f.file_name} className="border-b border-zinc-200 last:border-b-0" data-testid="backup-predeploy-row">
                    <td className="py-2 pr-4 font-mono text-xs">{f.file_name}</td>
                    <td className="py-2 pr-4">{fmtDateTime(f.mtime)}</td>
                    <td className="py-2 pr-4">{fmtSize(f.size_bytes)}</td>
                    <td className="py-2 pr-4 text-right">
                      <button
                        className="btn btn-ghost btn-sm"
                        onClick={() => onDownload(f.file_name)}
                        data-testid="backup-predeploy-download"
                      >
                        <DownloadSimple size={14} weight="bold" /> Baixar
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </section>
  );
}
